import styled from 'styled-components';

export const Tag = styled.div`
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #002131;
  box-shadow: 0 0.25rem 0.25rem rgb(1, 55, 82);
  padding: 8px;
  border-radius: 8px;
  width: 100%;
`;

export const TagText = styled.div`
  font-family: Rubik;
  font-size: 12px;
  font-weight: 700;
  line-height: 16.41px;
  text-align: center;
  color: #bcf738;
  padding-left: 8px;
  padding-right: 8px;
  white-space: nowrap;
`;

export const Container = styled.div`
  margin-bottom: 10px;
  @media screen and (max-width: 1025px) {
    padding-top: 0px;
  }
`;
